// @ts-strict-ignore
import { memo } from 'react'

import SvgArrow from '@/shared/lib/@deprecated/iport-icons/iconsB/delivery/SvgArrow'

import cl from './DeliveryTitle.module.scss'

const DeliveryTitle = ({ title, city }) => {
	return (
		<div className={cl.delivery__textWrapper}>
			<h1 className={cl.delivery__title}>{title}</h1>
			<div className={cl.delivery__btn}>
				<span className={cl.delivery__link}>{city}</span>
				<SvgArrow size={24} className={cl.delivery__icon} />
			</div>
		</div>
	)
}

export default memo(DeliveryTitle)
